// Explicit valid selections win; persisted intent is only for the same product.
export function resolvePurchaseBilling(query = {}, account = {}) {
  const valid = value => value === 'monthly' || value === 'annual';
  if (valid(query.billing)) return query.billing;
  const intent = account.purchaseIntent;
  if (intent?.plan === 'powerhouse' && valid(intent.billing)) return intent.billing;
  return 'annual';
}

export function powerhousePurchaseRoute(query = {}, account = {}) {
  return { name: 'PurchasePowerhouse', query: { ...query, billing: resolvePurchaseBilling(query, account) } };
}
